import { useFilterTimeControl } from '../../hooks/useFilterTimeControl';
import type { GroupType } from '../CmsGroup/types';
import { ComponentRecognizer } from '../ComponentRecognizer/ComponentRecognizer';

export const GroupOnImage = ({ paragraph }: { paragraph?: GroupType[] }) => {
  const filterTimeControl = useFilterTimeControl();
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {paragraph
        ?.filter((item) => filterTimeControl(item))
        ?.map((item) => {
          const { field_alignment: alignment, field_vertical_alignment: verticalAlignment } = item;
          const styleClasses = [
            '@container pointer-events-none absolute h-full w-full [&>_div]:absolute [&>_div.cms-group]:w-auto',
            alignment === 'left' ? '[&>_div.cms-group]:left-0' : null,
            alignment === 'right' ? '[&>_div.cms-group]:right-0' : null,
            alignment !== 'left' && alignment !== 'right' ? '[&>_div.cms-group]:left-1/2' : null,
            verticalAlignment === 'center' || verticalAlignment === 'stretch'
              ? '[&>_div.cms-group]:top-1/2'
              : null,
            verticalAlignment === 'bottom' || verticalAlignment === 'flex-end'
              ? '[&>_div.cms-group]:bottom-0'
              : null,
            verticalAlignment &&
            !['center', 'stretch', 'bottom', 'flex-end'].includes(verticalAlignment)
              ? '[&>_div.cms-group]:top-0'
              : null,
            alignment && !['left', 'right'].includes(alignment)
              ? '[&>_div.cms-group]:-translate-x-1/2'
              : null,
            verticalAlignment && ['center', 'stretch'].includes(verticalAlignment)
              ? '[&>_div.cms-group]:-translate-y-1/2'
              : null,
          ];
          return (
            <span className={styleClasses.join(' ').trim()} key={item.id}>
              <ComponentRecognizer item={item} />
            </span>
          );
        })}
    </>
  );
};
